import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import Arrow from "./img/white-arrow.png"

function Main() {
	const [data, setData] = useState([])
	const params = useParams()
	console.log(params.id)
	useEffect(() => {
		fetch(
			"https://sheet.best/api/sheets/48f24a76-4650-45dc-a294-27c9e9b26639?_raw=1",
		)
			.then((response) => response.json())
			.then((data) => {
				console.log(data)
				setData(data)
			})
			.catch((error) => {
				console.error(error)
			})
	}, [])
	return (
		<div className="main-wrapper-blog">
			<div className="outer-wrapper-blog">
				{data
					.filter((i) => {
						return i.url == params.id
					})
					.map((item) => {
						console.log(item)
						return (
							<div className="wrapper-blog">
								<div
									className="main-slide-blog one-blog"
									style={{ backgroundImage: `url(${item.image})` }}>
									<p>{item.title} </p>
									{/* <p>experiences for the digital</p> */}
									{/* <p>era.</p> */}
									<div>
										<img src={Arrow} alt="" />
									</div>
								</div>
								<div className="slide-blog one">
									<p>{item.summary}</p>
								</div>

								<div className="slide-blog two">
									<p>{item.para}</p>
									<p>{item.para}</p>
									<p>{item.para}</p>
								</div>

								<div className="slide-blog three">
									<div className="three-u">
										<p>
											Excited about more like this Article? Please get in touch.
										</p>
									</div>
									<div className="three-d">
										<div className="three-d-in">
											<h3>Contact</h3>
											<br />
											<p>Harsh raj</p>
										</div>
										<div className="three-d-in">
											<h3>Email</h3>
											<br />
											<p>harshuuu814@gmail.com</p>
										</div>
										<div className="three-d-in">
											<h3>Phone</h3>
											<br />
											<p>+91 9983396152</p>
										</div>
									</div>
								</div>

								{/* <div className="slide-blog ">
									<div className="slide-in-blog four">
										<div className="slide-in-title">
											<p>
												<code>{item.author} </code>
											</p>
											<h2>{item.title} </h2>
										</div>
									</div>
								</div> */}
							</div>
						)
					})}
			</div>
		</div>
	)
}

export default Main
